module.exports = __webpack_public_path__ + "img/logo.fb91e1e1.svg";